<template>
	<div class="grid p-mb-3 p-mt-6">
        <div class="p-text-center"><i class="pi pi-wifi" style="font-size: 2rem"></i></div>
		<div class="p-text-center"><h6>{{title}}</h6></div>
        <div class="p-text-center">{{message}}</div>
        <div class="p-text-center"><Button label="Reintentar" class="p-button-info p-mt-3" @click="checkWifi()"/></div>
	</div>

</template>

<script>
export default {
	data() {
		return {
			title: 'Algo salió mal',
            message: 'Cierra sesión e intentalo nuevamente.',
		}
	},	
	smartService: null,
	created() {
        
	},
	mounted() {
		
	},
	methods: {
		async checkWifi(){
            try {
            //ver que URL poner acá para verificar que tengamos internet y el server esté levantado
            const response = await fetch(localStorage.urlLogin);
            //Respuestas satisfactorias (200–299), Redirecciones (300–399), Errores de los clientes (400–499)
           if (response.status >= 200 && response.status < 500) {
                this.$router.replace({ name: "Datos personales" });
            }
            else if (response.status >= 500 && response.status <= 599){
                this.title='Algo salió mal';
                this.message='Cierra sesión e intentalo nuevamente en unos minutos.';
            }
            } catch(err) {
                this.title = 'Algo salió mal';
                this.message = 'Comprueba la conexión. Cierra sesión e intentalo nuevamente.';
            }
        }
	},
}
</script>

<style scoped lang="scss">
	
</style>